import React, { useEffect } from "react";
import Aos from "aos";
import ImageZoom from "react-medium-image-zoom";
import "aos/dist/aos.css";
import "react-medium-image-zoom/dist/styles.css";
import "./Noticias.css"; // importa o CSS novo

const noticiasData = [
  {
    "data": "04/10/2025",
    "titulo": "Automotive Industry Week",
    "descricao": "Plastifa sera présent à la 12e Semaine de l'industrie automobile, organisée par l'AFIA !\n Nous serons dans la salle « New York » de l'hôtel Solverde, à Vila Nova de Gaia, les 4, 5 et 6 novembre.",
    "imagem": "images/AFIA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_innovation-automotiveindustry-plastifa-activity-7378706061240926208-qsqS?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "02/10/2025",
    "titulo": "SCORING TOP 5%",
    "descricao": "Plastifa renouvelle son statut de « TOP 5 % des meilleures PME du Portugal » pour la sixième année consécutive.\n C'est avec une grande fierté que nous annonçons le renouvellement de cette distinction, décernée par SCORING.",
    "imagem": "images/TOP2025.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plastifa-top5-scoring-activity-7381254954105135104-Rcn0?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "01/09/2025",
    "titulo": "IAA MOBILITY 2025",
    "descricao": "PLASTIFA est heureux de participer à IAA MOBILITY 2025",
    "imagem": "images/IAA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plasticparts-mobility-automotive-activity-7360664420571578368-TTnd?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    data: "15/05/2024",
    titulo: "ISO 14001",
    descricao:
      "En mettant l’accent sur l’environnement et un avenir plus durable, Plastifa a été certifié ISO 14001 - Système de gestion environnementale.",
    imagem: "images/14001.jpeg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7196080381643616257",
  },
  {
    data: "23/12/2023",
    titulo: "Un avenir plus vert",
    descricao:
      "Dans un souci de durabilité et d'un avenir plus vert, Plastifa investit dans la production d'énergie solaire.",
    imagem: "images/PaineisSolares.JPG",
    link: "https://www.linkedin.com/posts/plastifa_com-foco-na-sustentabilidade-e-num-futuro-activity-7157008055249821696-QJP5",
  },
  {
    data: "25/10/2023",
    titulo: "SCORING TOP 5%",
    descricao:
      "Pour la quatrième année consécutive, l'entreprise a été reconnue dans le TOP 5% des MEILLEURES PME AU PORTUGAL en termes de Performance et de Solidité Financière !",
    imagem: "images/TOP52023.png",
    zoom: true,
  },
  {
    data: "01/06/2023",
    titulo: "Nouveau Vidéo",
    descricao:
      "Dans un monde conduit par le constant progrès et innovation, Plastifa est fière de vous faire une brève présentation de son entreprise avec technologies de pointe et idées innovantes.",
    imagem: "images/NotVideo.png",
    link: "https://www.linkedin.com/posts/plastifa_plastifa-your-partner-for-plastic-parts-activity-7059587841172865024-LQ9A",
  },
  {
    data: "17/10/2022",
    titulo: "SCORING TOP 5%",
    descricao:
      "Pour la troisième année consécutive, l'entreprise a été reconnue dans le TOP 5% des MEILLEURES PME AU PORTUGAL en termes de Performance et de Solidité Financière !",
    imagem: "images/TOPSCORING22.png",
    zoom: true,
  },
  {
    data: "23/12/2021",
    titulo: "Christmas Postcard",
    descricao: "Please click on the image below to access Plastifa Postcard:",
    imagem: "images/Natal-EN.png",
    link: "https://plastifa.pt/Christmas",
  },
  {
    data: "15/11/2021",
    titulo: "SCORING TOP 5%",
    descricao:
      "Pour la deuxième année consécutive, l'entreprise a été reconnue dans le TOP 5% des MEILLEURES PME AU PORTUGAL en termes de Performance et de Solidité Financière !",
    imagem: "images/TOP2021.jpg",
    zoom: true,
  },
  {
    data: "24/04/2021",
    titulo: "PME Excellence",
    descricao:
      "Plastifa renouvelle par la 7ème année consécutive son Status PME Excellence.",
    imagem: "images/PMEex3.png",
    zoom: true,
  },
  {
    data: "24/12/2020",
    titulo: "SCORING TOP 5%",
    descricao:
      "L'entreprise est reconnue comme part du TOP 5% MEILLEURES PME AU PORTUGAL au niveau de Perfomance et Solidité Fincancière!",
    imagem: "images/TOP52020.jpg",
    zoom: true,
  },
  {
    data: "16/04/2020",
    titulo: "EPI’s Plastifa",
    descricao:
      "De manière à faire sa part dans la lutte contre la pandémie COVID-19, Plastifa s'est dediée à la fabrication de Visières et Fixeurs pour masques.",
    imagem: "images/Viseiras.png",
    zoom: true,
  },
  {
    data: "02/10/2020",
    titulo: "Expansion de l'Unité 2",
    descricao:
      "Plastifa avance pour la construcion de plus un batîment de 1.000m² dans l'unité 2.",
    imagem: "images/NewInst.jpg",
    imagemExtra: "images/ExpUn2.jpeg",
    zoom: true,
  },
];

const Noticias = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  return (
    <div className="noticias-wrapper">
      <div className="noticias-grid">
        {noticiasData.map((noticia, idx) => (
          <article key={idx} className="noticia-card" data-aos="fade-up">
            <div className="noticias-row2">
              <label>{noticia.data}</label>
              <h3 className="noticia-titulo">{noticia.titulo}</h3>
            </div>
            <p
              className="noticia-desc"
              dangerouslySetInnerHTML={{
                __html: noticia.descricao.replace(/\n/g, "<br>")
              }}
            ></p>
            <div className="noticia-media">
              {noticia.zoom ? (
                <ImageZoom
                  image={{ src: noticia.imagem, alt: noticia.titulo, className: "noticia-img" }}
                  zoomImage={{ src: noticia.imagem, alt: noticia.titulo }}
                />
              ) : noticia.link ? (
                <a href={noticia.link} target="_blank" rel="noreferrer">
                  <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
                </a>
              ) : (
                <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Noticias;